import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=3b41653a&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=ts&"
export * from "./ChatWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=3b41653a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41653a",
  null
  
)

export default component.exports